import { render, staticRenderFns } from "./text-area.component.vue?vue&type=template&id=dd58f84e&scoped=true&"
import script from "./text-area.component.vue?vue&type=script&lang=ts&"
export * from "./text-area.component.vue?vue&type=script&lang=ts&"
import style0 from "./text-area.component.vue?vue&type=style&index=0&id=dd58f84e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd58f84e",
  null
  
)

export default component.exports